import React from 'react';

const LoadingOverlay = ({ isVisible, message = 'Processing...', details = '' }) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4 shadow-2xl">
        <div className="text-center">
          {/* Spinner */}
          <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-blue-600 mx-auto mb-4"></div>
          
          {/* Message */}
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            {message}
          </h3>
          
          {/* Details */}
          {details && (
            <p className="text-sm text-gray-600 mb-4">
              {details}
            </p>
          )}
          
          {/* Warning */}
          <div className="bg-yellow-50 border border-yellow-200 rounded-md p-3">
            <p className="text-xs text-yellow-800">
              ⚠️ Please wait - Do not refresh the page
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingOverlay;